import { FC } from "react";
import Select, { components, SingleValue } from "react-select";
import { IProduct } from "../config/interface";
import ValidCheckDropdownIndicator from "./ValidCheckDropdownIndicator";

type Props = {
  data: IProduct[];
  selectedValue: IProduct | null;
  onSelectProduct: (selectedProduct: SingleValue<IProduct>) => void;
  setSelectorRef: (ref: any) => void;
};

const ProductSelector: FC<Props> = (props: Props) => {
  const { data, selectedValue, onSelectProduct, setSelectorRef } = props;
  return (
    <div className="col-12 col-md-3 ps-md-0">
      <div className="form-group px-4 px-md-0">
        <label>Product</label>
        <Select
          ref={(ref) => setSelectorRef(ref)}
          components={{
            DropdownIndicator: !!selectedValue
              ? ValidCheckDropdownIndicator
              : components.DropdownIndicator,
          }}
          placeholder="Select"
          className="custom-select"

          value={selectedValue}

          options={data}

          getOptionLabel={(product) => product.name}
          getOptionValue={(product) => `${product.id}`}
          onChange={onSelectProduct}
          isSearchable={true}
          classNames={{
            control: (state) => {
              let selectClass = "form-control";
              selectClass = state.isFocused
                ? selectClass + " form-control-focus"
                : selectClass;
              return selectClass;
            },
            menu(state) {
              let selectClass = "react-select-listbox";
              return selectClass;
            },
          }}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: "#000000",
            },
          })}
          styles={{
            option: (base, { isFocused, isSelected }) => ({
              ...base,
              backgroundColor: isSelected
                ? "#000000"
                : isFocused
                ? "#f4f4f4"
                : "transparent",
              "&:hover": {
                backgroundColor: isSelected
                  ? "#000000"
                  : isFocused
                  ? "#f4f4f4"
                  : "transparent",
              },
            }),
          }}
        />
        <small className="form-text text-muted"></small>
      </div>
    </div>
  );
};


export default ProductSelector;